import {I18n, Translate} from 'react-redux-i18n';
import {Icon} from 'front-onceforall-core';
import Tooltip from '@material-ui/core/Tooltip';
import {notificationType} from '../../utils/constant';

const notificationData = {
  DOCUMENT_VALIDATED: notification => ({
    message: (
      <>
        <Translate
          value="notification.document.validated"
          documentName={notification.document.documentName}
        />
        {notification.document.expirationDate &&
            <Translate
              value="notification.document.validUntil"
              expirationDate={I18n.l(notification.document.expirationDate, {dateFormat: 'datetime.shortDate'})}
            />
        }
      </>
    ),
    action: {REDIRECT: '/documents'},
    icon: 'document'
  }),
  DOCUMENT_REQUALIFIED: notification => ({
    message: (
      <Translate
        value="notification.document.requalified"
        documentName={notification.document.documentName}
        certifyingThirdParty={notification.document.certifyingThirdParty}
        previousDocumentName={notification.document.previousDocumentName}
      />
    ),
    action: {REDIRECT: '/documents'},
    icon: 'document'
  }),
  DOCUMENT_CREATED: notification => ({
    message: (
      <Translate
        value="notification.document.created"
        documentName={notification.document.documentName}
      />
    ),
    action: {REDIRECT: '/documents'},
    icon: 'document'
  }),
  DOCUMENT_MANDATE_DISABLED: notification => ({
    message: (
      <>
        <Translate
          value={`notification.document.collectionMandateDisabled.${notification.document.documentCountry}`}
          documentName={notification.document.documentName}
        />
        <div
          className="ml-2"
          style={{display: 'inline-block'}}
        >
          <Tooltip
            placement="left"
            title={notification.document.collectionMandateDisabledReason}
          >
            <span>
              <Icon
                icon="info"
                size={16}
              />
            </span>
          </Tooltip>
        </div>
      </>
    ),
    action: {REDIRECT: '/documents'},
    icon: 'document'
  }),
  PROJECT_AUTOMATICALLY_ACCEPTED_AS_CLIENT: notification => ({
    message: (
      <Translate
        value="notification.project.accepted"
        projectName={notification.intervention.projectName}
      />
    ),
    action: {REDIRECT: `/project/${notification.intervention.projectId}/intervention/${notification.intervention.interventionId}`},
    icon: 'message'
  }),
  PROJECT_AUTOMATICALLY_ACCEPTED_AS_SUBCONTRACTOR: notification => ({
    message: (
      <Translate
        value="notification.project.accepted"
        projectName={notification.intervention.projectName}
      />
    ),
    action: {REDIRECT: `/project/${notification.intervention.projectId}/intervention/${notification.intervention.interventionId}`},
    icon: 'message'
  }),
  PROJECT_CLOSED: notification => ({
    message: (
      <Translate
        value="notification.project.closed"
        projectName={notification.project.projectName}
        organisationOwnerName={notification.project.organisationOwnerName}
      />
    ),
    action: {REDIRECT: `/project/${notification.targetId}/intervention/${notification.project.inAppNotificationOrganisationInterventionId}`},
    icon: 'message'
  }),
  PROJECT_REJECTED: notification => ({
    message: (
      <Translate
        value="notification.project.rejected"
        projectName={notification.intervention.projectName}
        invitedOrganisationName={notification.intervention.invitedOrganisationName}
        rejectionReason={I18n.t(`rejectionReason.reason.${notification.intervention.rejectionReason}`)}
      />
    ),
    action: {REDIRECT: `/project/${notification.intervention.projectId}/intervention/${notification.intervention.organisationSourceInterventionId}`},
    icon: 'message'
  }),
  REQUIRED_DOCUMENTS_IN_PROJECT_DOSSIER_OVERVIEW_UPDATED: notification => ({
    message: (
      <Translate
        value="notification.project.updatedRequiredDocumentsInProjectDossierOverview"
        projectName={notification.project.projectName}
      />
    ),
    action: {REDIRECT: `/project/${notification.targetId}/intervention/${notification.project.inAppNotificationOrganisationInterventionId}/required-documents`},
    icon: 'message'
  }),
  RELATIONSHIP_REJECTED: notification => ({
    message: (
      <Translate
        value="notification.relationship.rejected"
        invitedOrganisationName={notification.relationship.invitedOrganisationName}
        rejectionReason={I18n.t(`rejectionReason.reason.${notification.relationship.rejectionReason}`)}
      />
    ),
    action: {REDIRECT: '/subcontractors'},
    icon: 'message'
  }),
  PROJECT_ORGANISATION_ENDED_AS_CLIENT: notification => ({
    message: (
      <Translate
        value="notification.project.organisationEnded"
        projectName={notification.intervention.projectName}
        invitedOrganisationName={notification.intervention.invitedOrganisationName}
      />
    ),
    action: {REDIRECT: `/project/${notification.intervention.projectId}/intervention/${notification.intervention.interventionId}`},
    icon: 'message'
  }),
  PROJECT_ORGANISATION_ENDED_AS_SUBCONTRACTOR: notification => ({
    message: (
      <Translate
        value="notification.project.organisationEnded"
        projectName={notification.intervention.projectName}
        invitedOrganisationName={notification.intervention.invitedOrganisationName}
      />
    ),
    action: {REDIRECT: `/project/${notification.intervention.projectId}/intervention/${notification.intervention.interventionId}`},
    icon: 'message'
  }),
  RELATIONSHIP_AUTOMATICALLY_ACCEPTED_AS_CLIENT: notification => ({
    message: (
      <Translate
        value="notification.relationship.accepted.AS_CLIENT"
        invitingOrganisationName={notification.relationship.invitingOrganisationName}
      />
    ),
    action: {REDIRECT: `/subcontractor/${notification.relationship.organisationSourceId}`},
    icon: 'message'
  }),
  RELATIONSHIP_AUTOMATICALLY_ACCEPTED_AS_SUBCONTRACTOR: notification => ({
    message: (
      <Translate
        value="notification.relationship.accepted.AS_SUBCONTRACTOR"
        invitingOrganisationName={notification.relationship.invitingOrganisationName}
      />
    ),
    action: {REDIRECT: `/client/${notification.relationship.organisationSourceId}`},
    icon: 'message'
  }),
  USER_PERMISSIONS_UPDATED: notification => ({
    message: (
      <Translate
        value={`notification.user.permissionsUpdated.${notification.user.permission}.${notification.user.action}`}
        firstName={notification.user.firstName}
        lastName={notification.user.lastName}
        organisationName={notification.user.organisationName}
      />
    ),
    action: {REDIRECT: '/organisation/users'},
    icon: 'message'
  }),
  USER_ROLE_UPDATED: notification => ({
    message: (
      <Translate
        value={`notification.user.roleUpdated.${notification.user.role}`}
        firstName={notification.user.firstName}
        lastName={notification.user.lastName}
        organisationName={notification.user.organisationName}
      />
    ),
    action: {REDIRECT: '/organisation/users'},
    icon: 'message'
  }),
  USER_LINKED: notification => ({
    message: (
      <Translate
        value="notification.user.linked"
        firstName={notification.user.firstName}
        lastName={notification.user.lastName}
        organisationName={notification.user.organisationName}
      />
    ),
    action: {REDIRECT: '/organisation/users'},
    icon: 'message'
  }),
  AUTOMATIC_ACCEPTATION_ENABLED: () => ({
    message: (
      <Translate
        value="notification.organisation.automaticAcceptationEnabled"
      />
    ),
    action: {REDIRECT: '/organisation/details'},
    icon: 'message'
  }),
  DEPOSITOR_SERVICE_ACTIVATED: () => ({
    message: (
      <Translate
        value="notification.document.depositor"
      />
    ),
    action: {REDIRECT: '/documents'},
    icon: 'message'
  }),
  RELATED_ORGANISATION_DEACTIVATED_AS_CLIENT: notification => ({
    message: (
      <Translate
        value="notification.organisation.deactivation.relatedAsClient"
        organisationName={notification.organisation.fullName}
      />
    ),
    action: {REDIRECT: `/subcontractor/${notification.organisation.organisationId}`},
    icon: 'message'
  }),
  RELATED_ORGANISATION_DEACTIVATED_AS_SUBCONTRACTOR: notification => ({
    message: (
      <Translate
        value="notification.organisation.deactivation.relatedAsSubcontractor"
        organisationName={notification.organisation.fullName}
      />
    ),
    action: {REDIRECT: `/client/${notification.organisation.organisationId}`},
    icon: 'message'
  }),
  INVITED_ORGANISATION_DEACTIVATED: notification => ({
    message: (
      <Translate
        value="notification.organisation.deactivation.inviting"
        organisationName={notification.organisation.fullName}
      />
    ),
    action: {REDIRECT: '/subcontractors/invitations-sent'},
    icon: 'message'
  }),
  DOCUMENTS_REMINDER: notification => ({
    message: (
      <Translate
        value="notification.document.remind"
        userFullName={[notification.documentReminder.remindingUser.firstName, notification.documentReminder.remindingUser.lastName].join(' ')}
        organisationName={notification.documentReminder.remindedOrganisation.fullName}
      />
    ),
    action: {REDIRECT: '/documents'},
    icon: 'message'
  })
};

export function getNotificationData(notification) {
  return notificationData[notification.type] ?
    notificationData[notification.type](notification) : {
      message: <span>UNKNOWN NOTIFICATION: <strong>{notification.type}</strong></span>,
      icon: 'message'
    };
}

export const NOT_INFORMATIVE_NOTIFICATIONS = [
  notificationType.DOCUMENT_ALMOST_EXPIRED,
  notificationType.DOCUMENT_EXPIRED,
  notificationType.DOCUMENT_REJECTED,
  notificationType.DOCUMENT_AWAITING_SIGNATURE,
  notificationType.DOCUMENT_SIGNED_ALMOST_EXPIRED,
  notificationType.DOCUMENT_SIGNED_EXPIRED,
  notificationType.DOCUMENT_AT_DATE,
  notificationType.PROJECT_NOT_AUTOMATICALLY_ACCEPTED,
  notificationType.RELATIONSHIP_NOT_AUTOMATICALLY_ACCEPTED,
  notificationType.USER_PENDING
];

export const NOT_INFORMATIVE_NOTIFICATIONS_NOT_DEPOSITOR = [
  notificationType.DOCUMENT_ALMOST_EXPIRED,
  notificationType.DOCUMENT_EXPIRED,
  notificationType.DOCUMENT_REJECTED,
  notificationType.DOCUMENT_AWAITING_SIGNATURE,
  notificationType.DOCUMENT_SIGNED_ALMOST_EXPIRED,
  notificationType.DOCUMENT_SIGNED_EXPIRED,
  notificationType.DOCUMENT_AT_DATE,
  notificationType.DOCUMENT_VALIDATED,
  notificationType.DOCUMENT_REQUALIFIED,
  notificationType.DOCUMENT_CREATED,
  notificationType.DOCUMENT_MANDATE_DISABLED,
  notificationType.DOCUMENTS_REMINDER,
  notificationType.PROJECT_NOT_AUTOMATICALLY_ACCEPTED,
  notificationType.RELATIONSHIP_NOT_AUTOMATICALLY_ACCEPTED,
  notificationType.USER_PENDING
];

export const INVITATIONS = [
  notificationType.DOCUMENT_AT_DATE, // Temporarily keep this type in invitations until it is removed
  notificationType.PROJECT_NOT_AUTOMATICALLY_ACCEPTED,
  notificationType.RELATIONSHIP_NOT_AUTOMATICALLY_ACCEPTED,
  notificationType.USER_PENDING
];

export const INVITATIONS_NOT_DEPOSITOR = [
  notificationType.RELATIONSHIP_NOT_AUTOMATICALLY_ACCEPTED,
  notificationType.USER_PENDING
];
